import React from 'react';
import { Link as v4Link } from 'react-router-dom';

import { Link } from '@zillow/zrs-comet';
import { Text } from '@zillow/constellation';

// context
import { RMWContext } from 'app/shared/providers/RMWContext';

// components
import PropertyStatus from 'app/shared/components/soh/PropertyStatus';
import PropertyPanel from 'app/shared/components/soh/PropertyPanel';

// styled components
import {
    StyledCard,
    StyledPhotoAddressContainer,
    StyledPropertyPhotoContainer,
    StyledPropertyCardCTAContainer,
    StyledAddressContainer,
    StyledButton,
    StyledPropertyPanelContainer,
} from './StyledComponents';

const PropertyCard = (props) => {
    // context
    const { paths } = React.useContext(RMWContext);
    const { listing } = props;

    const {
        active,
        isFeed = '',
        photoUrl: primaryPhotoUrl,
        status,
    } = listing;

    const { code, message: statusMessage } = status;

    const getPropertyInfoLines = () => {
        const {
            address,
            isMultifamily,
            name,
        } = listing;

        const {
            city,
            state,
            street,
            unit,
            zip,
        } = address;

        const mfSummary = isMultifamily ? name : `${city}, ${state} ${zip}`;
        const sfSummary = unit ? `${street} ${unit}` : street;

        const firstLine = isMultifamily ? mfSummary : sfSummary;
        const secondLine = isMultifamily ? sfSummary : mfSummary;

        return { firstLine, secondLine };
    };

    const getCTAPath = () => {
        const { aliasEncoded } = listing;
        const { propertiesPage } = paths;
        const listingPagePath = `${propertiesPage}/${aliasEncoded}/listing`;

        return listingPagePath;
    };

    const ctaPath = getCTAPath();

    const handleCTAClick = (event) => {
        event.preventDefault();

        window.router.transitionTo(ctaPath);
    };

    const getCTAButton = () => {
        const activeTitle = 'Edit listing';
        const inactiveTitle = 'List property';
        const feedTitle = 'Manage';
        let title = null;

        if (isFeed) {
            title = feedTitle;
        } else {
            title = active ? activeTitle : inactiveTitle;
        }

        return (
            <Link
                className="StyledPropertyCard-CTA-Button-Anchor"
                to={ctaPath}
                reactRouterLink={v4Link}
            >
                <StyledButton
                    classname="StyledPropertyCard-CTA-Button"
                    buttonType="primary"
                    onClick={handleCTAClick}
                >
                    {title}
                </StyledButton>
            </Link>
        );
    };

    const getPanelList = () => {
        const { panels } = listing;

        return panels.map((item, index) => {
            const {
                badgeCount,
                iconName,
                isDisabled,
                message,
                title,
                urlPath,
            } = item;

            return (
                <PropertyPanel
                    key={index}
                    title={title}
                    message={message}
                    badgeCount={badgeCount}
                    iconName={iconName}
                    isDisabled={isDisabled}
                    urlPath={urlPath}
                />
            );
        });
    };

    const { firstLine, secondLine } = getPropertyInfoLines();

    return (
        <StyledCard className="SOHPropertyCard">
            <StyledPhotoAddressContainer onClick={handleCTAClick}>
                <StyledPropertyPhotoContainer
                    className="SOHPropertyCard-Property-Container"
                    primaryPhotoUrl={primaryPhotoUrl}
                >
                    <PropertyStatus
                        code={code}
                        message={statusMessage}
                    />
                </StyledPropertyPhotoContainer>

                <StyledPropertyCardCTAContainer className="SOHPropertyCard-CTA-Container">
                    <StyledAddressContainer className="SOHPropertyCard-Address-Container">
                        <Text
                            className="SOHPropertyCard-Address-Container-Street"
                            fontType="sectionheading"
                            as="h5"
                        >
                            {firstLine}
                        </Text>
                        <Text
                            className="SOHPropertyCard-Address-Container-CityStateZip"
                            fontType="smallbody"
                            as="p"
                        >
                            {secondLine}
                        </Text>
                    </StyledAddressContainer>

                    {getCTAButton()}
                </StyledPropertyCardCTAContainer>
            </StyledPhotoAddressContainer>

            <StyledPropertyPanelContainer className="SOHPropertyCard-PropertyPanelContainer">
                {getPanelList()}
            </StyledPropertyPanelContainer>
        </StyledCard>
    );
};

PropertyCard.propTypes = {};
PropertyCard.defaultProps = {};

export { PropertyCard };
export default PropertyCard;
